import React, { useState } from "react";
import axios from "axios";


const TradeFairForm = () => {
  const [formData, setFormData] = useState({
    source: "",
    tradeFairDate: "",
    companyName: "",
    customerName: "",
    surname: "",
    country: "",
    contact: "",
    email: "",
    categoryId: "",
    comments: "",
    priority: "",
    businessCard: null,
    clientPicture: null,
    emailType: "",
    datetime: "",
  });
  const api_url = process.env.REACT_APP_API_URL;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];

    if (file) {
      setFormData({ ...formData, [name]: file });
    }
  };

  // Handle QR Code upload and scanning
  const handleQRCodeUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      alert("Please select a QR code image before uploading.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    const token = localStorage.getItem("token"); // Get JWT token

    try {
      const response = await fetch(`${api_url}/api/qr-scanner`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.statusText}`);
      }

      const extractedData = await response.json();
      console.log("QR Code Extracted Data:", extractedData);

      // Get the first contact number (if exists)
      let firstContact = extractedData.contact?.split(",")[0]?.trim() || "";

      // Remove all non-numeric characters (special characters, spaces, dashes, etc.)
      firstContact = firstContact.replace(/\D/g, "");

      // Update form data
      setFormData((prev) => ({
        ...prev,
        companyName: extractedData.company || prev.companyName,
        customerName: extractedData.firstName || prev.customerName,
        surname: extractedData.lastName || prev.surname,
        email: extractedData.email || prev.email,
        contact: firstContact || prev.contact,
      }));

      alert("QR code data extracted successfully!");
    } catch (error) {
      console.error("Error processing QR code:", error);
      alert("Failed to process the QR code. Please make sure it's a valid QR code image.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for required fields
    const requiredFields = ["source", "tradeFairDate", "companyName", "customerName", "surname", "country", "contact", "email", "categoryId", "priority", "emailType", "datetime"];
    for (let field of requiredFields) {
      if (!formData[field]) {
        alert(`Please fill out the ${field} field.`);
        return;
      }
    }

    // Convert tradeFairDate to YYYY-MM-DD format
    const formattedTradeFairDate = new Date(formData.tradeFairDate).toISOString().split('T')[0];

    // Format datetime to match the format expected by the backend
    const formattedDatetime = new Date(formData.datetime).toISOString();

    const data = new FormData();
    data.append('source', formData.source);
    data.append('tradeFairDate', formattedTradeFairDate);
    data.append('companyName', formData.companyName);
    data.append('contactName', formData.contactName);
    data.append('customerName', formData.customerName);
    data.append('surname', formData.surname);
    data.append('country', formData.country);
    data.append('contact', formData.contact);
    data.append('email', formData.email);
    data.append('categoryId', formData.categoryId);
    data.append('comments', formData.comments);
    data.append('priority', formData.priority);
    data.append('emailType', formData.emailType);
    data.append('datetime', formattedDatetime);

    // Only append the files if they are selected
    if (formData.businessCard) data.append('businessCard', formData.businessCard);
    if (formData.clientPicture) data.append('clientPicture', formData.clientPicture);

    // Log the FormData to console
    console.log("FormData being sent: ");
    for (let pair of data.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    try {
      const response = await axios.post(`${api_url}/api/tradefair`, data, {
        headers: {
          "Content-Type": "multipart/form-data", // Ensure correct content type for files
        },
      });
      console.log("Response: ", response.data);
      alert("Form submitted successfully!");
    } catch (err) {
      console.error("Error response:", err.response);
      if (err.response) {
        console.error("Error details:", err.response.data); // Check for specific API error messages
      }
      alert("An error occurred while submitting the form.");
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-xl font-bold mb-4">Trade Fair Form</h1>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Form Fields */}
        <div>
          <label className="block text-sm font-medium mb-1">Source</label>
          <input
            type="text"
            name="source"
            value={formData.source}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Trade Fair Date</label>
          <input
            type="date"
            name="tradeFairDate"
            value={formData.tradeFairDate}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Company Name</label>
          <input
            type="text"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Customer Name</label>
          <input
            type="text"
            name="customerName"
            value={formData.customerName}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Surname</label>
          <input
            type="text"
            name="surname"
            value={formData.surname}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Contact Name</label>
          <input
            type="text"
            name="contactName"
            value={formData.contactName}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Country</label>
          <input
            type="text"
            name="country"
            value={formData.country}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Contact Number</label>
          <input
            type="text"
            name="contact"
            value={formData.contact}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Category ID</label>
          <input
            type="text"
            name="categoryId"
            value={formData.categoryId}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Comments</label>
          <textarea
            name="comments"
            value={formData.comments}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          ></textarea>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Priority</label>
          <input
            type="text"
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Email Type</label>
          <input
            type="text"
            name="emailType"
            value={formData.emailType}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Datetime</label>
          <input
            type="datetime-local"
            name="datetime"
            value={formData.datetime}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Business Card</label>
          <input
            type="file"
            name="businessCard"
            onChange={handleFileChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Scan QR Code</label>
          <input
            type="file"
            name="qrCode"
            accept=".jpg,.jpeg,.png"
            onChange={handleQRCodeUpload}
            className="w-full border-gray-300 rounded-lg p-2"
          />
          <small className="text-gray-500 text-xs">
            Upload a QR code image containing contact information
          </small>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Client Picture</label>
          <input
            type="file"
            name="clientPicture"
            onChange={handleFileChange}
            className="w-full border-gray-300 rounded-lg p-2"
          />
        </div>
        <div className="col-span-1 md:col-span-2">
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default TradeFairForm;
